import clsx from 'clsx';
import styles from './index.module.scss';

export const MainContainer: React.FC<{
  gray?: boolean;
  children: React.ReactNode;
  isFlex?: boolean;
}> = ({ gray, children, isFlex }) => {
  return (
    <div className={clsx(styles.mainContainer, gray && styles.gray)}>
      <div className={clsx(styles.content, isFlex && styles.flex)}>{children}</div>
    </div>
  );
};

export const MainContainerWithSideBar: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <div className={styles.mainContainerWithSideBar}>{children}</div>;
};
